import React from 'react';
import { MiniGoogleMap } from './GoogleMap';

// Mini map component that uses Google Maps
const MiniMapPreview = ({ 
  latitude, 
  longitude, 
  address,
  height = '150px',
  showNavigate = true,
  onClick 
}) => {
  return (
    <MiniGoogleMap
      latitude={latitude}
      longitude={longitude}
      address={address}
      height={height}
      showNavigate={showNavigate}
      onClick={onClick}
    />
  );
};

export default MiniMapPreview;
